import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { take } from 'rxjs/operators';
import { DynamicComponentDialogComponent } from './dynamic-component-dialog/dynamic-component-dialog.component';
import { DynamicComponentSelectorService } from './dynamic-component-selector.service';

@Component({
  selector: 'templates-dynamic-component-selector',
  templateUrl: 'dynamic-component-selector.component.html',
  styleUrls: ['dynamic-component-selector.component.scss'],
  standalone: false,
})
export class DynamicComponentSelectorComponent {
  @Input() marketId: string;
  @Input() target: HTMLTextAreaElement;
  @Input() model: string;

  @Output() modelChange: EventEmitter<string> = new EventEmitter<string>();

  public variablesReady = this.variableService.hasComponentsToDisplay();

  constructor(
    private dialog: MatDialog,
    private variableService: DynamicComponentSelectorService,
  ) {}

  openDialog(): void {
    const dialogRef = this.dialog.open(DynamicComponentDialogComponent, {
      width: '450px',
      height: '450px',
    });
    dialogRef
      .afterClosed()
      .pipe(take(1))
      .subscribe((res: string | null) => {
        if (res) {
          this.selectVariable(res);
        }
      });
  }

  selectVariable(replacementTag: string): void {
    const startPos = this.target.selectionStart;
    const endPos = this.target.selectionEnd ?? startPos;

    const contentBefore = this.target.value.substr(0, startPos);
    const contentAfter = this.target.value.substr(endPos, this.target.value.length);

    const newValue = contentBefore + replacementTag + contentAfter;
    this.target.value = newValue;
    this.target.selectionStart = startPos;

    this.modelChange.emit(newValue);

    // Using setTimeout fix bug where input does not focus
    window.setTimeout(() => {
      this.target.focus();
      this.target.setSelectionRange(startPos, replacementTag.length + startPos);
    }, 0);
  }
}
